// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  width: 100%;
}

#limit-container-footer {
  margin-top: 20px;
}
#limit-container-footer button {
  margin-right: 15px;
}

.limit-color {
  width: 100% !important;
  max-width: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sensor-limit/sensor-limit.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AACA;EACE,gBAAA;AAEF;AADE;EACE,kBAAA;AAGJ;;AACA;EACE,sBAAA;EACA,0BAAA;AAEF","sourcesContent":["mat-form-field {\n  width: 100%;\n}\n#limit-container-footer {\n  margin-top: 20px;\n  button {\n    margin-right: 15px;\n  }\n}\n\n.limit-color {\n  width: 100% !important;\n  max-width: none !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
